import { baseUrl } from './consts';
import { APP_BASE_ROUTE, APP_PAGES } from '../constants/routes';
import { QueryParams } from '../constants/QueryParams';

export const getReturnToTemplateIdFromLogin = (templateId: string) => {
  const url = `${baseUrl}${APP_BASE_ROUTE}${APP_PAGES.TEMPLATE_PAGE}?${QueryParams.ID}=${templateId}&${QueryParams.RETURNED_FROM_LOGIN_PAGE}=true`;
  return { encodedCurrentUrl: encodeURIComponent(url), currentUrl: url };
};
